<template>
  <div :class="[$style.attachment, $style[theme]]">
    <div v-if="isPhoto" :style="{ width: `${imageDisplayRes.width}px` }" :class="$style.imgWrap" @click.stop>
      <MessageContentText v-if="message.payload" v-bind="{ message, theme }" :class="$style.text" />
      <RadialProgressBar
        v-if="message.isPending"
        :diameter="40"
        :innerStrokeWidth="4"
        :strokeWidth="4"
        startColor="#ffffff"
        stopColor="#ffffff"
        :completedSteps="message.attachment.progress"
        :totalSteps="1"
        :class="$style.progress"
      />
      <div v-viewer="{ title: true }" style="font-size: 0">
        <img
          v-lazy="message.attachment.link"
          :width="imageDisplayRes.width"
          :height="imageDisplayRes.height"
          :alt="message.attachment.name"
          :class="$style.img"
        />
      </div>
    </div>
    <div v-else-if="isVideo && !message.isPending" @click.stop>
      <MessageContentText v-if="message.payload" v-bind="{ message, theme }" :class="$style.text" />
      <video :src="message.attachment.link" ref="video" :width="maxRes.maxWidth" preload="metadata" controls></video>
    </div>
    <div v-else-if="isAudio && !message.isPending" @click.stop>
      <MessageContentText v-if="message.payload" v-bind="{ message, theme }" :class="$style.text" />
      <div :class="$style.audioName">
        {{ message.attachment.name }}
        <div :class="$style.size">({{ size }})</div>
      </div>
      <audio :src="message.attachment.link" preload="metadata" controls></audio>
    </div>
    <template v-else>
      <MessageContentText
        v-if="message.payload || (message.properties && message.properties.subject)"
        v-bind="{ message, theme }"
        :class="$style.text"
      />
      <a :href="message.attachment.link" target="_blank" :class="$style.file" @click.stop>
        <div :class="[$style.iconWrap, $style[theme]]">
          <RadialProgressBar
            v-if="message.isPending"
            :diameter="36"
            :innerStrokeWidth="2"
            :strokeWidth="2"
            startColor="#00b764"
            stopColor="#00b764"
            innerStrokeColor="#ffffff"
            :completedSteps="message.attachment.progress"
            :totalSteps="1"
            :class="$style.progress"
          />
          <BaseIcon name="file" :class="$style.icon" />
        </div>
        <div :class="$style.attachmentName">
          <a @click.stop :href="message.attachment.link" target="_blank">{{ message.attachment.name }}</a>
          <div :class="$style.size">({{ size }})</div>
        </div>
      </a>
    </template>
  </div>
</template>

<script>
import MessageContentText from './Text'
import { ATTACHMENT_NAME } from '@/models/Message'
import superbytes from 'superbytes'
import RadialProgressBar from 'vue-radial-progress'
import { calculateAspectRatioFit } from '@/utils/helpers'

export default {
  name: 'message-content-attachment',
  components: {
    MessageContentText,
    RadialProgressBar
  },
  props: {
    message: {
      type: Object,
      required: true
    },
    theme: {
      type: String,
      default: ''
    },
    isForwarded: Boolean
  },
  data () {
    return {
      videoEl: null,
      videoSize: null
    }
  },
  mounted () {
    if (this.isVideo) {
      this.getVideoDisplayRes()
    }
  },
  computed: {
    typeName () {
      return ATTACHMENT_NAME[this.message.attachment.type]
    },
    isPhoto () {
      return this.typeName === 'image'
    },
    isVideo () {
      return this.typeName === 'video'
    },
    isAudio () {
      return this.typeName === 'audio'
    },
    imageRes () {
      if (!this.isPhoto) return
      const [width, height] = this.message.attachment.resolution.split('x')
      return { width, height }
    },
    maxRes () {
      let maxWidth = 480
      let maxHeight = 320
      if (this.isForwarded) {
        maxWidth = 360
        maxHeight = 280
      }
      return {
        maxWidth,
        maxHeight
      }
    },
    imageDisplayRes () {
      if (!this.imageRes) return
      const { width, height } = this.imageRes
      const { maxWidth, maxHeight } = this.maxRes
      return calculateAspectRatioFit({ width, height, maxWidth, maxHeight })
    },
    size () {
      return superbytes(this.message.attachment.size)
    }
  },
  methods: {
    getVideoDisplayRes () {
      const el = this.$refs.video
      if (!el) return
      el.onloadedmetadata = () => {
        const { videoWidth, videoHeight } = el
        const { maxWidth, maxHeight } = this.maxRes
        const ratioSize = calculateAspectRatioFit({
          width: videoWidth,
          height: videoHeight,
          maxWidth,
          maxHeight
        })
        el.width = ratioSize.width
        el.height = ratioSize.height
      }
    }
  }
}
</script>

<style module lang="scss">
.attachment {
  & > * {
    font-size: 0px;
  }
}
.green {
  .size {
    color: $white;
  }
  .iconWrap {
    background: $white;
  }
  .icon {
    color: $white;
  }
  .iconWrap {
    background-color: rgba($white, 0.15);
  }
}
.text {
  padding: 8px;
}
.imgWrap {
  position: relative;
  .progress {
    top: calc(50% - 20px);
    left: calc(50% - 20px);
  }
}
.attachmentName {
  font-size: 14px;
  min-width: 150px;
}
.progress {
  position: absolute;
}
.img {
  // max-width: 85%;
  // max-height: 300px;
  object-fit: contain;
  max-width: 100% !important;
  // object-position: left top;
}
.iconWrap {
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba($main-bg-colored, 0.15);
  margin-right: 8px;
  flex-shrink: 0;
  position: relative;
}
.icon {
  font-size: 20px;
  color: $text-colored;
}
.file {
  display: flex;
  align-items: center;
  padding: 8px;
  a {
    @include ellipsis();
  }
}
.size {
  color: $text-light;
  font-size: 12px;
}
.audioName {
  margin-bottom: 6px;
}
</style>
